import Image from 'next/image';
import { CompetitorComparison } from '@/shared/types/landing-page';
import { STATIC_FILE_URL } from '@/shared/constants';
import './index.less';

export default function CompetitorComparisonBox({ comparison }: { comparison: CompetitorComparison }) {
  return (
    <div className="competitor-comparison-box">
      <div className="box competitor">
        <Image
          width={120}
          height={32}
          src={comparison.competitor.logo}
          alt={comparison.competitor.name}
          title="competitor.name"
          loading="eager"
          className="comparison-logo"
        />
        <div className="checklist">
          {comparison.competitor.items.map((item) => (
            <div className="checklist-item" key={item}>
              <Image
                width={20}
                height={20}
                src={`${STATIC_FILE_URL}/9a1dc85904cb1e552d24628e015d99f2.svg`}
                alt="Not included"
                title="Not included"
                loading="eager"
                className="not-included"
              />
              <span className="checklist-item-text">{item}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="box pietra">
        <Image
          width={124}
          height={32}
          src={`/images/${comparison.pietra.logo}`}
          alt="Pietra"
          title="Pietra"
          loading="eager"
          className="comparison-logo"
        />
        <div className="checklist">
          {comparison.pietra.items.map((item) => (
            <div className="checklist-item" key={item}>
              <Image
                width={20}
                height={20}
                src={`${STATIC_FILE_URL}/786fc219f8abbf924d0bd62abdd11976.png`}
                alt="Included"
                title="Included"
                loading="eager"
                className="included"
              />
              <span className="checklist-item-text">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
